import { SurveyAnswer } from '../services/survey/types';

const ANSWERS_STORAGE_KEY = 'survey:answers';
const ACTIVE_SURVEY_STORAGE_KEY = 'survey:activeSurveyId';
const STEP_STORAGE_PREFIX = 'survey:step:';

export const readStoredAnswers = (): Record<string, SurveyAnswer[]> => {
    const raw = sessionStorage.getItem(ANSWERS_STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
};

export const writeStoredAnswers = (answers: Record<string, SurveyAnswer[]>): void => {
    sessionStorage.setItem(ANSWERS_STORAGE_KEY, JSON.stringify(answers));
};

export const readStoredActiveSurveyId = (): string | null => {
    return sessionStorage.getItem(ACTIVE_SURVEY_STORAGE_KEY);
};

export const writeStoredActiveSurveyId = (surveyId: string): void => {
    sessionStorage.setItem(ACTIVE_SURVEY_STORAGE_KEY, surveyId);
};

export const clearStoredActiveSurveyId = (): void => {
    sessionStorage.removeItem(ACTIVE_SURVEY_STORAGE_KEY);
};

export const readStoredStep = (surveyId: string): number => {
    const raw = sessionStorage.getItem(STEP_STORAGE_PREFIX + surveyId);
    const parsed = raw ? parseInt(raw, 10) : 0;
    return Number.isNaN(parsed) ? 0 : parsed;
};

export const writeStoredStep = (surveyId: string, stepIndex: number): void => {
    sessionStorage.setItem(STEP_STORAGE_PREFIX + surveyId, String(stepIndex));
};

export const clearStoredStep = (surveyId: string): void => {
    sessionStorage.removeItem(STEP_STORAGE_PREFIX + surveyId);
};